import { Component, OnInit, ViewEncapsulation, HostListener, Inject, Input, AfterViewInit } from '@angular/core';
import { OvsComponent, Core, LabelNames, ApplicationConfiguration, QueryParamService } from '../../shared/core/ovs.core';
import { DOCUMENT } from "@angular/platform-browser";
import { ResortComponent } from '../../shared/resort.component';
import { Router } from '@angular/router';
import { BootstrapHelperService } from '../../instrumentation/bootstrap-helper.service';

@Component({
  selector: 'partner-header',
  templateUrl: './partner-header.component.html',
  styleUrls: ['./partner-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PartnerHeaderComponent extends ResortComponent implements AfterViewInit {
  private _document: Document;


  public logoUrl: string;
  public myAccountHRef: string;
  public myAccountText: string;
  public phoneNumber: string;
  public logoNavigationUrl: string;
  public isMenuOpen: boolean = false;
  public isNavFixed: boolean;
  public count: number;
  private _router: Router;
  private _core: Core;
  private _qryParamService: QueryParamService;
  public logoUrl1: string;
  public logoNavigationUrl1: string;
  public altImageUrl: string;
  public partnerId: string;
  public alreadyBookedText: string;
  public alreadyBookedHRef: string;
  public showAlreadyBookedText: boolean = false;
  public hasPartnerSecondLogo: boolean = false;

    public get isGuestCheckout(): boolean {
      return this.application.configuration.IsGuestCheckOutMode;
    }

    public get UseAlternateMobileNavLayout(): boolean {
        return this.application.configuration.UseAlternateMobileNavLayout;
   }

    public get hasPartnerBadge(): boolean {
            return this.application.configuration.HeaderDisplayOptions.HasPartnerBadge;
    }

  public get hasPartnerLink(): boolean {
    return this.application.configuration.HeaderDisplayOptions.HasBackToPartnerSiteLink;

  }

  public get partnerCssClass(): string{
    return this.application.configuration.HeaderDisplayOptions.PartnerCssClass;
  }

  public get partnerName(): string{
    return this.configuration.Partner.LongName;
  }

  public get partnerUrl(): string{
    return this.application.configuration.HeaderDisplayOptions.BackToPartnerSiteLinkUrl;
  }

  public get partnerLinkTitle(): string{
    return this.application.configuration.HeaderDisplayOptions.BackToPartnerSiteLinkHoverText;
  }

  public get partnerBadgeLogoUrl(): string{
   return this.application.configuration.HeaderDisplayOptions.PartnerBadgeLogoUrl;
  }

  public get displayContactUsToBook(): boolean{
     return !this._core.currentConfiguration.HasOnlineBooking && (this._router.url.indexOf("/resort-standard") >=0 || this._router.url.indexOf("/resort-detail") >=0);
    }


 constructor( @Inject(DOCUMENT) document: Document, router: Router, core: Core, qryParamService: QueryParamService, private btsHelperService: BootstrapHelperService) {
    super();
    this._document = document;
    this._router = router;
    this._core = core;
    this._qryParamService = qryParamService;
    this.btsHelperService.PartnerHeaderLoadedCount=this.btsHelperService.PartnerHeaderLoadedCount+1;
     this.count = this.btsHelperService.PartnerHeaderLoadedCount;
  }

  public initialize(): void {
      super.initialize();

      var alreadyBookedHRef = this.application.configuration.HeaderDisplayOptions.AlreadyBookedLinkUrl;;
      var alreadyBookedText = this.application.configuration.HeaderDisplayOptions.AlreadyBookedLinkText;
      this.alreadyBookedHRef = alreadyBookedHRef ? alreadyBookedHRef : "";
      this.alreadyBookedText = alreadyBookedText ? alreadyBookedText : "";

      if (this.alreadyBookedText != 'undefined' && this.alreadyBookedText && this.alreadyBookedText.length > 0) {
          this.showAlreadyBookedText = true;
      }
  }

  public toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  public logoClicked(): void {
      this._router.navigate(["/"]);
  }

  protected configurationChanged(): void {
      let config: ApplicationConfiguration = this.configuration;

    var logo = config && config.Logos && config.Logos.firstOrDefault();
    var labels = config && config.Labels;
    var myAccountHRef = labels && labels.firstOrDefault(l => l.Name == LabelNames.MyAccountHRef);
    var myAccountText = labels && labels.firstOrDefault(l => l.Name == LabelNames.AccountSettingsLabel);

    this.logoUrl = logo ? logo.ImageUrl : "";
    this.logoNavigationUrl =  logo ? logo.NavigationUrl : "";
    this.myAccountHRef =  myAccountHRef ? myAccountHRef.DisplayText : "---";
    this.myAccountText =  myAccountText ? myAccountText.DisplayText : "---";
    this.phoneNumber = config && config.Partner ? config.Partner.PhoneNumber : "---";

      var logo1 = config && config.Logos && config.Logos[1];
      this.hasPartnerSecondLogo = logo1 != null && logo1 != undefined && logo1.ImageUrl.length > 0;
      this.logoUrl1 = logo1 ? logo1.ImageUrl : "";
      this.logoNavigationUrl1 = logo1 ? logo1.NavigationUrl : "";
      this.partnerId = config && config.Partner ? config.Partner.Id : "";
      if (config.Logos[0] && config.Logos[0].AltImageUrl) {
        this.altImageUrl = config.Logos[0].AltImageUrl;
      } else {
        this.altImageUrl = "";
      }
  }

  ngAfterViewInit():void{

  }

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 150) {
      this.isNavFixed = true;
    } else if (this.isNavFixed && number < 10) {
      this.isNavFixed = false;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/header/partner-header/partner-header.component.ts